const MesosConstants = {
  // Minimum number of cpus per offer.
  MIN_CPUS: 0.01,
  // Minimum amount of memory per offer.
  MIN_MEM: 32
};

module.exports = MesosConstants;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/MesosConstants.js